export default __webpack_public_path__ + "static/media/myfavourites.2e74418f.svg";